import(/* webpackMode: "eager" */ "/local/p4clients/pkgbuild-const/workspace/src/AWSMarketingHorizonWebsite/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/local/p4clients/pkgbuild-const/workspace/src/AWSMarketingHorizonWebsite/src/components/Common/AWSCloudWatchRealUserMointor.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/local/p4clients/pkgbuild-const/workspace/src/AWSMarketingHorizonWebsite/src/components/Footer/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/local/p4clients/pkgbuild-const/workspace/src/AWSMarketingHorizonWebsite/src/components/Navigation/Navigation.tsx");
;
import(/* webpackMode: "eager" */ "/local/p4clients/pkgbuild-const/workspace/src/AWSMarketingHorizonWebsite/src/styles/globals.css");
